<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year" :data1="graph1.data1" :data2="graph1.data2" @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <monthly-comparison-card :title="graph2.title" :year="graph2.year" :month="graph2.month" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph2.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph2(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </monthly-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <daily-comparison-card dateType="yyyy-mm" :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="graph3.month" :list="graph3.list" @change="dateRangeChangeForGraph3">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx"
                       :color="button.dataType === graph3.dataType ? 'primary' : 'secondary'"
                       class="py-3 px-0 lg:px-8" type="border" @click="dataTypeChangeForGraph3(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </daily-comparison-card>
      </vs-col>
    </div>
  </vs-row>
</template>

<script>
/* eslint-disable brace-style */
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard";

export default {
  name: "GraphDetail85",
  components: {
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    getFieldLabel() {
      return `${this.projectId}` === '2' ? '작업장' : '공중(다중)이용시설';
    },
    getButtons() {
      switch (this.getLevel) {
      case 1:
        return [
          {label: '부서(국)', dataType: 'company1'},
          {label: '부서(과)', dataType: 'company2'},
          {label: '구분', dataType: 'field_cat1'},
          { label: this.getFieldLabel, dataType: 'field' },
          { label: '재해형태', dataType: 'disaster' },
        ];
      case 2:
        return [
          {label: '부서(국)', dataType: 'company0'},
          {label: '부서(과)', dataType: 'company1'},
          {label: '구분', dataType: 'field_cat1'},
          { label: this.getFieldLabel, dataType: 'field' },
          { label: '재해형태', dataType: 'disaster' },
        ];
      case 3:
        return [
          {label: '부서(과)', dataType: 'company0'},
          {label: '구분', dataType: 'field_cat1'},
          { label: this.getFieldLabel, dataType: 'field' },
          { label: '재해형태', dataType: 'disaster' },
        ];
      case 4:
        return [
          {label: '구분', dataType: 'field_cat1'},
          { label: this.getFieldLabel, dataType: 'field' },
          { label: '재해형태', dataType: 'disaster' },
        ];
      }
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  data() {
    return {
      buttons: [
        { label: '부서', dataType: 'company' },
        { label: '사업장', dataType: 'field' },
        { label: '재해형태', dataType: 'detail' },
      ],
      boardId: 158,
      summaryKey: ["위험요인파악_공정명", "sum"],
      graph1: {
        title: "전체 (공중(다중)이용시설) 유해·위험요인 점검(개선) 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
      },
      graph2: {
        title: "월별 (공중(다중)이용시설) 유해·위험요인 점검(개선) 현황",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        unit: "",
        heads: [{ name: "No." }, { name: "부서명" }, { name: "건" }, { name: "전월대비 증감" }],
        list: [],
        dataType: this.$route.params.proj_id ? "company" : "project",
      },
      graph3: {
        title: "기간별 (공중(다중)이용시설) 유해·위험요인 점검(개선) 현황",
        unit: "",
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        // beginDate: new Date().format("yyyy-MM-dd"),
        // endDate: new Date().format("yyyy-MM-dd"),
        list: [],
        dataType: this.$route.params.proj_id ? "company" : "project",
      },
      cache: {},
      loading: false,
    };
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.loadDetailData();

    this.graph2.dataType = this.getButtons[0].dataType;
    this.graph3.dataType = this.getButtons[0].dataType;
    this.dataTypeChangeForGraph2(this.getButtons[0].dataType, this.getButtons[0].label);

    await this.loadGraph1();
    await this.loadGraph2();
    await this.loadGraph3();
  },
  methods: {
    // API에서 상세 정보를 불러온다
    async loadDetailData(currentYear, depth = -1) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (depth < 0) {
        depth = 1;
      }

      const cacheKey = `detail_${currentYear}_${depth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          projectId: this.projectId,
          boardIds: [160],
          fieldCode: 'facility-public',
          depth,
        };

        this.$vs.loading();
        this.loading = true;
        try {
          const data = await this.$store.dispatch("summary/LOAD_DONUT_08_DETAIL", params);
          this.$vs.loading.close();
          this.loading = false;
          this.cache[cacheKey] = data;
          return data;
        } catch (e) {
          this.$vs.loading.close();
          this.loading = false;
          this.$vs.notify({title: "Error", text: "데이터를 불러오는데 실패했습니다.", color: "danger"});
        }
      }
    },
    // 그래프 1
    async loadGraph1() {
      const yyyy = this.graph1.year;
      const data = await this.loadDetailData(yyyy);
      const graph1Data = data.monthly;
      const currentYear = graph1Data[yyyy] ? graph1Data[yyyy] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const prevYear = graph1Data[yyyy - 1] ? graph1Data[yyyy - 1] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      // 첫번째 배열은 총 합이므로, 데이터에서 제외한다
      currentYear.shift();
      prevYear.shift();

      this.graph1.data1 = currentYear;
      this.graph1.data2 = prevYear;
      this.graph1.sum1 = `${prevYear[prevYear.length - 1]}`;
      this.graph1.sum2 = `${currentYear[currentYear.length - 1]}`;
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 그래프 2
    async loadGraph2() {
      const yyyy = this.graph2.year;
      let depth = 1;
      if (this.graph2.dataType === "company2") {
        depth = 2;
      }
      else if (this.graph2.dataType === "company0") {
        depth = 0;
      }
      const data = await this.loadDetailData(yyyy, depth)

      let graph2Data = [];
      switch (this.graph2.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph2Data = data.company;
        break;
      case "field":
        graph2Data = data.field;
        break;
      case "field_cat1":
        graph2Data = data.facilityCategory;
        break;
      case "disaster":
        graph2Data = data.disaster;
        break;
      default:
        return;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph2.month;
      const prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      const prevMonth = currentMonth === 1 ? 12 : currentMonth - 1;

      const currentData = graph2Data[currentYear][currentMonth];
      const prevData = graph2Data[prevYear][prevMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.count - prevRow.count : row.count;
        list.push({
          no,
          name: row.label,
          value: new Intl.NumberFormat().format(row.count),
          valueRaw: row.count,
          gap,
        });
        no += 1;
      }

      // prevData 중에서 list에 포함되지 않은 데이터를 찾아서 추가한다
      for (const row of prevData) {
        const currentRow = currentData.find((item) => item.label === row.label);
        if (!currentRow) {
          list.push({
            no,
            name: row.label,
            value: 0,
            valueRaw: 0,
            gap: -row.count,
          });
          no += 1;
        }
      }

      // list를 value 기준으로 내림차순 정렬한다
      list.sort((a, b) => b.valueRaw - a.valueRaw);

      this.graph2.list = list;
    },
    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) return value.value;
      if (index === 3) {
        let updown = "default";
        if (value.gap > 0) updown = "up";
        else if (value.gap < 0) updown = "down";
        return { type: updown, value: new Intl.NumberFormat().format(value.gap) };
      }
      return "";
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;
      this.loadGraph2();
    },
    dataTypeChangeForGraph2(dataType, label) {
      this.graph2.heads[1].name = label;
      if (this.projectId) {
        this.graph2.dataType = dataType;
        this.loadGraph2();
      }
    },

    // 그래프 3
    async loadGraph3() {
      const yyyy = this.graph3.year;
      let depth = 1;
      if (this.graph3.dataType === 'company0') {
        depth = 0;
      } else if (this.graph3.dataType === 'company1') {
        depth = 1;
      } else if (this.graph3.dataType === 'company2') {
        depth = 2;
      }

      const data = await this.loadDetailData(yyyy, depth)
      let graph2Data = [];
      switch (this.graph3.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph2Data = data.company;
        break;
      case "field":
        graph2Data = data.field;
        break;
      case "field_cat1":
        graph2Data = data.facilityCategory;
        break;
      case "disaster":
        graph2Data = data.disaster;
        break;
      default:
        return;
      }

      const currentYear = this.graph3.year;
      const currentMonth = this.graph3.month;
      const currentData = graph2Data[currentYear][currentMonth];

      const list = [];
      // console.log(graph2Data);

      for (const row of currentData) {
        list.push({
          label: row.label,
          value: row.count,
        });
      }

      this.graph3.list = list;
    },
    dateRangeChangeForGraph3(year, month) {
      this.graph3.year = year;
      this.graph3.month = month;
      // this.graph3.beginDate = beginDate;
      // this.graph3.endDate = endDate;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType, /*label*/) {
      if (this.projectId) {
        this.graph3.dataType = dataType;
        this.loadGraph3();
      }
    },
  },
};
</script>

<style scoped></style>
